import gql from 'graphql-tag';
import { useEffect, useState } from 'react';
import Hideable from './Hideable';
import moment from 'moment';
import AdContent from './AdContent';
import AutoContent from './AutoContent';
import { useQuery } from '@apollo/client';
import { Box, CircularProgress, IconButton, LinearProgress, Stack } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import TravelControl from './TravelControl';
import { useDrawer } from './context/DrawerContext';

const TRAVEL_BY_ID = gql`
  query TravelById($travelId: String!, $first: Int, $limit: Int) {
      observation(criteria: {subjectId: $travelId, first: $first, limit: $limit, sensor: "travel.assessment"}) {
          countReturned
          countAvailable
          observations {
              id
              modified
              title
              category
              type
              start
              end
              contentType
              content
          } 
      }
      travelInformation(travel: $travelId) {
        id
        created
        label
        departure
        arrival
        status
      }
  }`;

const POLL_INTERVAL = 10000;

const isLoaded = data => {
    if (typeof data === 'undefined') {
        return false;
    }
    var count = data?.observation?.countReturned
    var loaded = typeof count !== undefined && count > 0
    return loaded
}

const Travel = props => {
    const [done, setDone] = useState(false)
    const [travelData, setTravelData] = useState(null)
    const {openDrawer} = useDrawer()

    const { loading, error, data, refetch } = useQuery(
        TRAVEL_BY_ID,
        {
            client: props.client,
            variables: { name: props.name, travelId: props.id, first: 1, limit: 5 },
            skip: (!props.id && !props.name),
            pollInterval: POLL_INTERVAL,
            fetchPolicy: 'network-only',
            //Necessary to trigger oncompleted after refetch
            notifyOnNetworkStatusChange: true,
            onCompleted: d => {
                console.log("Loaded travel content")
                setTravelData(d)
                if (!isLoaded(d)) {
                    console.log("Scanning is not done")
                    setTimeout(reload, 2000)
                } else {
                    console.log("Scanning is done")
                    setDone(true)
                }
            }
        })

    const reload = () => {
        console.log("Reload")
        if (done) {
            console.log("Done reloading")
            return
        }
        refetch()
    }

    useEffect(() => {
        console.log("Start reload");
        reload();
    }, [])

    if (error) {
        return "Error: " + error
    }

    if (!data || (!data.observation && !data.observation)) {
        return <CircularProgress />
    }

    return (<Box sx={{ padding: 2 }}>
        <IconButton onClick={() => openDrawer("drive")}><ArrowBack /></IconButton>
        <TravelContent
            data={data}
            account={props.account}
            client={props.client}
            id={props.id}
            onError={props.onError}
            onCompleted={id => console.log("Initiated re-scan for " + id)}
            refresh={() => {
                refetch()
            }}
            scanning={!done || loading}
            complete={travelData?.travelInformation?.status === 'COMPLETE'}
            activeState={props.activeState}
        />
    </Box>)
}

const parseObservations = obs => {
    obs = obs || { countAvailable: 1, observations: [] };

    obs = ({
        ...obs,
        observations: obs.observations.map(o => ({
            ...o,
            content: (typeof (o?.content) === 'string' && o?.contentType?.endsWith("+json")) ? JSON.parse(o.content) : o.content
        }))
    })

    return obs;
}

const TravelContent = props => {
    const data = props.data;
    const obs = parseObservations(data.observation)
    const MAX_SCAN_TIME_MINUTES = 5;
    const travelAgeMinutes = ageMinutes(data.travelInformation?.created);
    const routing = travelAgeMinutes < MAX_SCAN_TIME_MINUTES && obs?.observations?.length === 0;
    const scanning = false;
    const observation = data?.observation?.observations?.[0];

    const travel = data?.travelInformation

    document.title = `navscout - ${travel?.label}`;

    if (!travel) {
        return <CircularProgress />
    }

    return (<Box>
        <AdContent id='ad' />

        <Hideable hidden={!routing && !scanning}>
            <h2>This route is being scanned.</h2>
            <LinearProgress />
        </Hideable>

        <Hideable hidden={routing || scanning}>

        </Hideable>

        <AutoContent
            client={props.client}
            content={observation?.content}
            contentType={observation?.contentType}
        />

        <Hideable hidden={!travel.id}>
            <Stack direction="row" spacing={1} justifyContent="flex-start">
                <TravelControl
                    client={props.client}
                    id={travel.id}
                    status={travel.status}
                    onComplete={() => { }}
                    onError={props.onError}
                />
            </Stack>
        </Hideable>
    </Box>)
}

const ageMinutes = t => moment().diff(moment(t), 'minutes')

export default Travel;
